import React, { ReactElement } from 'react'
import { ArtData } from '@/database/art'
import Button from '@/components/Button'
import { crazyAmount, forSaleButtonText, priceText, transferFeeText } from '@/utils/formatting'
import Box from '@/components/boxes/Box'
import LoadImageButtonOnDemand from '@/components/LoadImageButtonOnDemand'
import { custodial } from '@/utils/extras'
import { ArtState } from '@/database/types'
import ClaimsReceivedTooltip from '@/components/tooltips/ClaimsReceivedTooltip'
import ClaimsMadeTooltip from '@/components/tooltips/ClaimsMadeTooltip'

const MarketCard = ({
    artData,
    openModalMarketCardDetails,
}: {
    artData: ArtData
    openModalMarketCardDetails: (artData: ArtData) => void
}): ReactElement => {
    return (
        <div className="header-container center">
            <div key={artData.art.id} className="artwork-box">
                <div className="header-container bottom">
                    <Box caption={'NFT'} text={'#' + (artData.tokenId ? artData.tokenId : artData.art.id)} />
                    <Box caption={'Title'} text={artData.art.title} />
                </div>
                {artData.highestOffer && (
                    <div className="header-container bottom">
                        <Box
                            caption={'Highest Offer'}
                            text={crazyAmount(artData.highestOffer, `white large-bold`)}
                            textValue={artData.highestOffer}
                            styleCaption={'gradient-text bold large-bold '}
                            styleText={'center nav__voted-amount large'}
                        />
                    </div>
                )}
                <LoadImageButtonOnDemand artData={artData} onClick={() => openModalMarketCardDetails(artData)} />
                <div className="header-container bottom">
                    <Box
                        caption={'Description'}
                        styleCaption={'small gray'}
                        styleText={'small white'}
                        text={artData.art.prompt}
                    />
                </div>
                <ClaimsMadeTooltip artData={artData} />
                <ClaimsReceivedTooltip artData={artData} />
                <div className={'header-container'}>
                    <Box caption={'Claim Power'} text={artData.claimPower.toFixed(2)} />
                    <Box
                        caption={'Claims Made'}
                        id={'claims-made' + artData.art.id}
                        text={artData.totalClaims.toFixed(2)}
                    />
                    <Box
                        caption={'Claims Received'}
                        id={'claims-received' + artData.art.id}
                        text={artData.totalClaimed.toFixed(2)}
                    />
                </div>
                <div className={'header-container'}>
                    <Box
                        caption={'Sale Price'}
                        text={priceText(artData)}
                        textValue={artData?.art.price}
                        triggerAnimation={false}
                    />
                    <Box
                        caption={'Transfer Fee'}
                        text={transferFeeText(artData)}
                        textValue={artData?.art.transferFee}
                        triggerAnimation={false}
                    />
                </div>
                <Button
                    btnName={
                        artData.art.state === ArtState.NOT_FOR_SALE && artData.art.currentOwner !== custodial
                            ? `Make An Offer`
                            : forSaleButtonText(artData)
                    }
                    classStyles={'nav__medium long-button pink'}
                    handleClick={() => openModalMarketCardDetails(artData)}
                    cancelBg={undefined}
                />
            </div>
        </div>
    )
}
MarketCard.whyDidYouRender = true

export default MarketCard
